var _path, _path2, _rect, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 1.25C3.25 0.973858 3.47386 0.75 3.75 0.75H12.6072C12.7398 0.75 12.867 0.802678 12.9608 0.896447L14.4697 2.40533L16.6036 4.53921C16.6973 4.63298 16.75 4.76016 16.75 4.89277V18.75C16.75 19.0261 16.5261 19.25 16.25 19.25H3.75C3.47386 19.25 3.25 19.0261 3.25 18.75V1.25Z",
    fill: "white",
    stroke: "#282725",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.625V3.125C12.5 3.81536 13.0596 4.375 13.75 4.375H16.875",
    stroke: "#282725",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 8.75,
    width: 13.75,
    height: 6.5625,
    rx: 0.625,
    fill: "#282725"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.20512 13.75H3.01512V12.78H3.67012C4.44512 12.78 4.94512 12.195 4.94512 11.515C4.94512 10.835 4.44512 10.25 3.67012 10.25H2.20512V13.75ZM3.57012 12.12H3.01512V10.91H3.57012C3.91012 10.91 4.13012 11.19 4.13012 11.515C4.13012 11.84 3.91012 12.12 3.57012 12.12ZM5.62895 10.25V13.75H6.91395C8.07895 13.75 8.73395 12.895 8.73395 12C8.73395 11.105 8.07395 10.25 6.91395 10.25H5.62895ZM6.87395 10.95C7.52895 10.95 7.90895 11.46 7.90895 12C7.90895 12.54 7.52895 13.05 6.87395 13.05H6.43895V10.95H6.87395ZM11.6126 10.93V10.25H9.47758V13.75H10.2876V12.54H11.6126V11.875H10.2876V10.93H11.6126Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdf);
export default __webpack_public_path__ + "static/media/icon-pdf.fc3626e6a47a22dadedcbe068e1b6ff7.svg";
export { ForwardRef as ReactComponent };